{
    "TelsysList_Column_TelSysID": "IDENTIFIANT",
    "TelsysList_Column_Description": "Description",
    "TelsysList_Column_Trial": "Procès",
    "TelsysList_Trial_Yes": "Oui",
    "TelsysList_Trial_No": "Non",
    "TelsysList_Column_PlatformType": "Type de plateforme",
    "TelsysList_Column_Licence": "Licence",
    "TelsysList_Column_Partitions": "Cloisons",
    "TelsysList_Column_Extensions": "Extensions",
    "TelsysList_Column_AcdAgents": "Agents ACD",
    "TelsysList_Column_AppUsers": "Utilisateurs de l'application",
    "TelsysList_Column_Status": "Statut",
    "TelsysList_Filter_PlatformType": "Type de plateforme",
    "TelsysList_Filter_ReportLicence": "Licence de déclaration",
    "TelsysList_Filter_ModuleStatus": "État du module",
    "TelsysList_LicenceFilter_HistoricOnly": "Historique seulement",
    "TelsysList_LicenceFilter_Standard": "Standard \/ BLF",
    "TelsysList_LicenceFilter_Enterprise": "Entreprise",
    "TelsysList_LicenceFilter_Acd": "ACD",
    "TelsysList_LicenceFilter_None": "Aucun",
    "TelsysList_LicenceFilter_Mixed": "Mixte",
    "TelsysList_LicenceFilter_Unknown": "Inconnu",
    "TelsysList_ModuleStatus_mNeg1": "Inconnu",
    "TelsysList_ModuleStatus_m0": "Tout juste en train de démarrer ou fermé",
    "TelsysList_ModuleStatus_m1": "Arrêté",
    "TelsysList_ModuleStatus_m2": "Départ",
    "TelsysList_ModuleStatus_m3": "Fin",
    "TelsysList_ModuleStatus_m4": "Désactivé",
    "TelsysList_ModuleStatus_m5": "En cours d'exécution (inactif)",
    "TelsysList_ModuleStatus_m6": "Fonctionnement (sans licence)",
    "TelsysList_ModuleStatus_m7": "Démarrage des communications de base",
    "TelsysList_ModuleStatus_m8": "Démarrage de la surveillance des appareils",
    "TelsysList_ModuleStatus_m9": "Arrêt des communications",
    "TelsysList_ModuleStatus_m10": "En cours d'exécution",
    "TelsysList_ModuleStatus_m11": "En cours d'exécution (avertissements)",
    "TelsysList_ModuleStatus_m12": "Synchronisation",
    "TelsysList_ModuleStatus_m13": "Synchronisé",
    "TelsysList_ModuleStatus_m14": "Synchronisé (avertissements)",
    "TelsysList_ModuleStatus_m15": "Échec de la synchronisation",
    "TelsysList_ModuleStatus_m16": "Hors service",
    "TelsysList_ModuleStatus_m17": "Les communications se sont terminées brutalement.",
    "TelsysList_ModuleStatus_m18": "Échec de la synchronisation",
    "TelsysList_ModuleStatus_m19": "Bots désactivés",
    "TelsysList_ModuleStatus_m20": "Bots désactivés (avertissements)",
    "TelsysList_ModuleStatus_m21": "Inactif (autorisation incorrecte)",
    "TelsysList_CountLink_PartitionsAria": "Partitions ouvertes filtrées vers ce serveur de téléphonie",
    "TelsysList_CountLink_ExtensionsAria": "Extensions ouvertes (codes) filtrées vers ce serveur de téléphonie",
    "TelsysList_CountLink_AcdAgentsAria": "Agents Open ACD filtrés vers ce serveur de téléphonie",
    "TelsysList_CountLink_AppUsersAria": "Utilisateurs de l'application ouverte filtrés vers ce serveur de téléphonie",
    "NAME": "Liste des langues Telsys"
}